import { Component, OnInit } from '@angular/core';
import { routerTransition } from './router.animations';
import { AuthenticationService } from './shared/index';
import { ActivatedRoute, Router } from '@angular/router';
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    animations: [routerTransition()]

})
export class AppComponent implements OnInit {
    constructor(private authenticationService: AuthenticationService,
        private route: ActivatedRoute,
        private router: Router) {
    }

    ngOnInit() {
        this.authenticationService.webRequestFrom().subscribe(
            data => {

                console.log("countrcode="+data.country_code);
                if (data.country_code == "US" || (data.country_code.toUpperCase() === "Not Found".toUpperCase())) {
                    console.log("redirect to dashboard");
                   // this.router.navigate(['access-denied']);
                } else {
                    console.log("redirect to error page");
                    this.router.navigate(['access-denied']);
                }
            },
            error => {
                console.log("Error");
            });
    }

}






// WEBPACK FOOTER //
// ./src/app/app.component.ts